/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { ValidationUnion_UserFriendly_Fragment, ValidationUnion_InvalidFormat_Fragment } from '../../../../common/queries/queryTyping/validation-unions';
import { gql } from '@apollo/client';
import { ValidationUnionFragmentDoc } from '../../../../common/queries/queryTyping/validation-unions';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SetUserPasswordMutationVariables = Types.Exact<{
  data: Types.SetUserPasswordInput;
}>;


export type SetUserPasswordMutation = (
  { __typename?: 'Mutation' }
  & { setUserPassword: Types.Maybe<(
    { __typename?: 'SetUserPasswordResult' }
    & Pick<Types.SetUserPasswordResult, 'successSummary' | 'successful'>
    & { warnings: Array<Types.Maybe<(
      { __typename?: 'UserFriendly' }
      & ValidationUnion_UserFriendly_Fragment
    ) | (
      { __typename?: 'InvalidFormat' }
      & ValidationUnion_InvalidFormat_Fragment
    )>>, errors: Array<Types.Maybe<(
      { __typename?: 'UserFriendly' }
      & ValidationUnion_UserFriendly_Fragment
    ) | (
      { __typename?: 'InvalidFormat' }
      & ValidationUnion_InvalidFormat_Fragment
    )>> }
  )> }
);


export const SetUserPasswordDocument = gql`
    mutation setUserPassword($data: SetUserPasswordInput!) {
  setUserPassword(setUserPasswordInput: $data) {
    successSummary
    successful
    warnings {
      ...ValidationUnion
    }
    errors {
      ...ValidationUnion
    }
  }
}
    ${ValidationUnionFragmentDoc}`;
export type SetUserPasswordMutationFn = Apollo.MutationFunction<SetUserPasswordMutation, SetUserPasswordMutationVariables>;

/**
 * __useSetUserPasswordMutation__
 *
 * To run a mutation, you first call `useSetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPasswordMutation, { data, loading, error }] = useSetUserPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPasswordMutation, SetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPasswordMutation, SetUserPasswordMutationVariables>(SetUserPasswordDocument, options);
      }
export type SetUserPasswordMutationHookResult = ReturnType<typeof useSetUserPasswordMutation>;
export type SetUserPasswordMutationResult = Apollo.MutationResult<SetUserPasswordMutation>;
export type SetUserPasswordMutationOptions = Apollo.BaseMutationOptions<SetUserPasswordMutation, SetUserPasswordMutationVariables>;